import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientProfileNameLabel from "@Broker/@Modules/clients/board/client-profile/components/shared/client-profile-name-label.vue";
import MergeClientProfileWarning from "./shared/merge-client-profile-warning";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ClientProfileContentTemplate from "@Broker/@HandlebarsTemplates/clients/applications/modals/_client-profile-select-content.hbs";
import Select2 from "@Shared/components/inputs/select2";
import Icon from "@Shared/components/general/fa-icon";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { LOAD_BOARD_CLIENTS } from "@Broker/@Modules/clients/board/store/board-actions";
import { cloneDeep, filter, findKey, isEmpty, map, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MergeClientProfileModal",
  components: {
    GenericModal,
    SimpleButton,
    Select2,
    Icon,
    InlinePrompt,
    MergeClientProfileWarning,
    ClientProfileNameLabel
  },
  mixins: [validationMixin],
  validations: {
    clientProfileToMerge: {
      id: {
        required
      }
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    clientProfileOrigin: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      clientProfileToMerge: {},
      autocompleteStyles: {
        vueSimpleSuggest: "simple-autocomplete",
        suggestItem: "simple-autocomplete-suggest-item"
      },
      columns: ["mergeProperty", "clientProfileOrigin", "clientProfileToMerge"],
      clientProfilesMergeData: {
        origin: {
          applications: false,
          label: false,
          timeline: false,
          personalInformation: false
        },
        toMerge: {
          applications: false,
          label: false,
          timeline: false,
          personalInformation: false
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("BoardStore", ["boards", "clientProfiles"])), {}, {
    isValid() {
      return !this.$v.$invalid && this.allMergePropertiesSelected;
    },
    tableData() {
      return [{
        key: "label",
        label: this.$t("global.words.label"),
        inputType: "radio"
      }, {
        key: "applications",
        label: this.$tc("global.doorr.application", 2),
        inputType: "radio"
      }, {
        key: "timeline",
        label: this.$t("client-profile.messages.timeline"),
        inputType: "checkbox"
      }, {
        key: "personalInformation",
        label: this.$t("request-package.requestApplicationDetails.personalInformation"),
        inputType: "radio"
      }];
    },
    allMergeProperties() {
      return map(this.tableData, data => data.key);
    },
    selectedMergeProperties() {
      var _context;
      const {
        origin,
        toMerge
      } = this.clientProfilesMergeData;
      return _filterInstanceProperty(_context = this.allMergeProperties).call(_context, mergeProperty => origin[mergeProperty] === true || toMerge[mergeProperty] === true);
    },
    allMergePropertiesSelected() {
      return this.allMergeProperties.length === this.selectedMergeProperties.length;
    },
    profilesByBoard() {
      const profilesWithoutCurrent = filter(this.boards.byId[this.boardId].boardProfiles, profileId => profileId !== this.clientProfileOrigin.id);
      return values(map(profilesWithoutCurrent, profileId => {
        const currentProfile = this.clientProfiles.byId[profileId];
        return currentProfile;
      }));
    },
    selectOptions() {
      return {
        closeOnSelect: true,
        allowClear: false,
        templateResult: this.formatResult,
        placeholder: this.$tc("global.doorr.clientProfile", 1),
        dropdownParent: "#select-client-profile-container",
        minimumInputLength: 3
      };
    },
    options() {
      return {
        filterable: false,
        sortable: [],
        headings: {
          mergeProperty: this.$t("client-profile.messages.mergeProperty")
        },
        columns: ["mergeProperty", "clientProfileOrigin", "clientProfileToMerge"],
        columnsClasses: {
          mergeProperty: "w-30",
          clientProfileOrigin: "w-auto text-center",
          clientProfileToMerge: "w-auto text-center"
        },
        skin: "table table-hover",
        perPage: 999999
      };
    },
    shouldShowProfileIndicator() {
      const equalNames = this.$options.filters.fullName(this.clientProfileOrigin) === this.$options.filters.fullName(this.clientProfileToMerge);
      const noLabels = !(this.clientProfileOrigin.labelText || this.clientProfileToMerge.labelText);
      return equalNames && noLabels;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARD_CLIENTS])), {}, {
    handleSubmit() {
      const mergeData = this.parseMergeData();
      this.$emit("submit", {
        mergeData,
        secondClientProfileId: this.clientProfileToMerge.id
      });
    },
    parseMergeData() {
      var _context2;
      //Parses the data to how the backend is expecting it
      const parser = {
        origin: 0,
        toMerge: 1,
        both: 2
      };
      return _reduceInstanceProperty(_context2 = this.allMergeProperties).call(_context2, (mergeData, mergeProperty) => {
        const includedInBoth = this.clientProfilesMergeData.origin[mergeProperty] === true && this.clientProfilesMergeData.toMerge[mergeProperty] === true;
        const parsedValue = includedInBoth ? parser.both : parser[findKey(this.clientProfilesMergeData, mergeData => mergeData[mergeProperty] === true)];
        mergeData[mergeProperty] = parsedValue;
        return mergeData;
      }, {});
    },
    hideModal() {
      this.$refs.mergeModal.hide();
    },
    handleSelectClientProfile(profile) {
      this.clientProfileToMerge = profile;
    },
    handleChangeMergeProperty({
      mergeProperty,
      clientProfileSelection,
      checked,
      type
    }) {
      const canBeBoth = type === "checkbox";
      const otherProfileSelection = clientProfileSelection === "origin" ? "toMerge" : "origin";
      this.clientProfilesMergeData[clientProfileSelection][mergeProperty] = checked;
      if (!canBeBoth) this.clientProfilesMergeData[otherProfileSelection][mergeProperty] = !checked;
    },
    resetData() {
      this.clientProfileToMerge = {};
    },
    formatResult(state) {
      return $(ClientProfileContentTemplate(_objectSpread({}, state)));
    },
    formatData(data) {
      const dataToUse = cloneDeep(data);
      return dataToUse && _mapInstanceProperty(dataToUse).call(dataToUse, clientProfile => {
        return _objectSpread(_objectSpread({}, clientProfile), {}, {
          text: this.$options.filters.fullName(clientProfile),
          id: clientProfile.id
        });
      });
    },
    async handleShow() {
      await this.$nextTick();
      this.$refs.selectClientProfile.initSelect2();
      if (isEmpty(this.boards.byId)) return;
      if (isEmpty(this.boards.byId[this.boardId].boardProfiles)) {
        await this.LOAD_BOARD_CLIENTS({
          boardId: this.boardId
        });
      }
    },
    isCheckbox(inputType) {
      return inputType === "checkbox";
    }
  })
});